import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Connect, PropsFromRedux } from './ExactDateSelectorsContainer';
import { searchConstants } from '../../../../search-utils/searchConstants';
import {
  withRestrictedModal,
  WithRestrictedModalProps,
} from '../../../../../components/modal/components/modal-restricted/withRestrictedModal';
import { doctrineAnalytics } from '../../../../../utils/analyticsUtils';
import { CommonSection } from '../../CommonSection';
import { withUser } from '../../../../../user/UserContext';
import { DaySelector } from '../DaySelector';
import { UserContextType } from '../../../../../user/user.types';
import { SearchCheckbox } from '../../checkbox/SearchCheckbox';

type OwnProps = {
  type: string;
};

type Props = PropsFromRedux &
  UserContextType &
  WithRestrictedModalProps &
  OwnProps;

type State = {
  isSelected: boolean;
};

export class RawExactDateSelectors extends React.Component<Props, State> {
  state: State = {
    isSelected: !!this.props.selectedValue,
  };

  componentDidUpdate(prevProps: Props) {
    if (prevProps.selectedValue !== this.props.selectedValue) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        isSelected: !!this.props.selectedValue,
      });
    }
  }

  toggleDate = () => {
    const {
      accessPremium,
      openRestrictedModal,
      onDatesUpdate,
      selectedValue,
    } = this.props;
    if (!accessPremium) {
      openRestrictedModal('faceted-item');
      return;
    }

    doctrineAnalytics('Search DateSelectorClicked', {
      search_type: this.props.type,
    });

    this.setState(state => ({
      isSelected: !state.isSelected,
    }));

    if (this.state.isSelected && !!selectedValue) onDatesUpdate({});
  };

  render() {
    const {
      accessPremium,
      openRestrictedModal,
      onDatesUpdate,
      selectedValue,
    } = this.props;
    const { isSelected } = this.state;

    return (
      <CommonSection title={searchConstants.filters.inForceDates}>
        <SearchCheckbox onClick={this.toggleDate} isSelected={isSelected}>
          <FormattedMessage id="search/components/aside-filters/dates/legislation/ExactDateSelectors.tsx/1" />
        </SearchCheckbox>
        {isSelected && (
          <DaySelector
            accessPremium={accessPremium}
            openRestrictedModal={openRestrictedModal}
            onDatesUpdate={onDatesUpdate}
            selectedValue={selectedValue}
            type={this.props.type}
            formatDate={(date: string) => ({
              exact: date,
            })}
          />
        )}
      </CommonSection>
    );
  }
}

export const ExactDateSelectors = withRestrictedModal(
  withUser(Connect(RawExactDateSelectors)),
);
